export const types = {
  SET_PROFILE: "SET_PROFILE",
  UPDATE_PROFILE: "UPDATE_PROFILE",
};

export const setProfile = payload => ({
  type: types.SET_PROFILE,
  payload,
});

export const updateProfile = payload => ({
  type: types.UPDATE_PROFILE,
  payload,
});
